/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

loadStyles([{"rawString":".ColorPickerExample{width:100%;padding-top:10px}"}]);
/* tslint:enable */